import type { WorkspaceCabinet, WorkspacePayload, WorkspaceUpdate } from "@wms/domain";
import { api } from "./client";
import { portalApi } from "./portal";

/**
 * ТЗ «Рабочие столы» 31.10.2026: the own look of the signed-in principal. Staff and the client cabinet have separate
 * endpoints and tokens — a client token never goes to the staff settings (UXW-13).
 */
export const workspaceApi = {
  get(cabinet: WorkspaceCabinet): Promise<WorkspacePayload> {
    return cabinet === "portal" ? portalApi.get<WorkspacePayload>("/me/workspace") : api.get<WorkspacePayload>("/auth/me/workspace");
  },
  save(cabinet: WorkspaceCabinet, body: WorkspaceUpdate): Promise<WorkspacePayload> {
    return cabinet === "portal" ? portalApi.put<WorkspacePayload>("/me/workspace", body) : api.put<WorkspacePayload>("/auth/me/workspace", body);
  },
};

/** The query key of the look: the principal is part of it, so a cache never shows one person's choice to another. */
export function workspaceKey(cabinet: WorkspaceCabinet, principal: string | undefined): unknown[] {
  return ["workspace", cabinet, principal ?? "-"];
}
